import React from "react"
import ParentHomeWithExtraHours from "./ParentHomeWithExtraHours"
import ParentSubscriptionPortalScreen from "./ParentSubscriptionPortalScreen"
import ParentTabScreenWrapper from "./ParentTabScreenWrapper"
import { isBlockOn, TENANT_BLOCKS } from "@data/utility/tenantBlocks"
import { ActivitiesScreen } from "../../../ports/primary/ui/screens/parent/Activities/ActivitiesScreen"
import { LiveReportsScreen } from "../../../ports/primary/ui/screens/parent/LiveReports/LiveReportsScreen"

// Wrapper function to create wrapped screen components.
// Accepts optional `headerOptions` that are forwarded to the shared
// ParentTabScreenWrapper (e.g. glow).
const createWrappedScreen = (ScreenComponent, headerOptions = {}) => {
    return (props) => (
        <ParentTabScreenWrapper {...props} {...headerOptions}>
            <ScreenComponent {...props} />
        </ParentTabScreenWrapper>
    )
}

// Create wrapped components ONCE, outside the function to prevent remounting
// L'accueil est le seul onglet qui porte la lueur : la coquille la peint derrière le header et
// l'écran, depuis le coin haut-droit.
const WrappedParentHomeScreen = createWrappedScreen(ParentHomeWithExtraHours, {
    glow: true,
})
const WrappedParentLiveReportsScreen = createWrappedScreen(LiveReportsScreen)
const WrappedParentActivitiesScreen = createWrappedScreen(ActivitiesScreen)
// Le portail est un onglet à part entière : il reprend le header de l'espace, sans titre ni bouton
// de fermeture — on ne ferme pas un onglet, on en change.
const WrappedParentSubscriptionPortalScreen = createWrappedScreen(
    ParentSubscriptionPortalScreen
)

export const parentTabScreens = (user) => {
    const screens = [
        {
            name: "parent-home",
            component: WrappedParentHomeScreen,
            options: { headerTitle: "Accueil", headerShown: false },
        },
        {
            name: "parent-activities",
            component: WrappedParentActivitiesScreen,
            options: { headerTitle: "Activités", headerShown: false },
        },
        {
            name: "parent-reports",
            component: WrappedParentLiveReportsScreen,
            options: { headerTitle: "Rapports", headerShown: false },
        },
        {
            name: "parent-subscription",
            component: WrappedParentSubscriptionPortalScreen,
            options: { headerTitle: "Abonnement", headerShown: false },
        },
    ]

    // Bloc « abonnement » éteint dans l'espace de l'élève : pas de portail.
    if (!isBlockOn(user, TENANT_BLOCKS.SUBSCRIPTION)) {
        return screens.filter((screen) => screen.name !== "parent-subscription")
    }

    return screens
}
